import { DatePipe, formatDate } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CourseVisit } from 'src/app/models/course-visit';
import { Visit } from 'src/app/models/visit';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VisitsService {
  private readonly serviceName = 'visits';
  private readonly headers = { headers: new HttpHeaders({ "Authorization": `Bearer ${environment.apiKeyInternal}`})
  };

  constructor(private http: HttpClient) {}

  /** The course of plan pid running at date (date + time), with its students. */
  public get(date: Date, pid = 1): Observable<CourseVisit> {
    const body = new HttpParams()
      .set('date', formatDate(date, 'yyyy-MM-dd', 'en-US'))
      .set('time', formatDate(date, 'HH:mm', 'en-US'))
      .set('pid', pid);

    return this.http.post<CourseVisit>(
      `${environment.apiUrl}${this.serviceName}/get.php`,
      body.toString(),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${environment.apiKeyInternal}`
        })
      }
    );
  }

  public set(visit: Visit): Observable<boolean> {
    const payload = `cid=${visit.cid}&sid=${visit.sid}&date=${formatDate(visit.date, 'yyyy-MM-dd', 'en-US')}`;

    return this.http.post<boolean>(
      `${environment.apiUrl}${this.serviceName}/set.php`,
      payload,
      this.headers
    );
  }

  public del(visit: Visit): Observable<boolean> {
    // Delete accepts no payload
    const payload = `cid=${visit.cid}&sid=${visit.sid}&date=${formatDate(visit.date, 'yyyy-MM-dd', 'en-US')}`;

    return this.http.post<boolean>(
      `${environment.apiUrl}${this.serviceName}/del.php`,
      payload,
      this.headers
    );
  }
}
